namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    /*
     * options: 
     *  tableControl: instance of DataTableControl    
     */
    export class TableSettingsDialog {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _tableMods;

        public _dialog: Solovis.UI.Dialog;
        public _formBuilder: Solovis.UI.InputControls.FormBuilder;


        constructor(options) {
            this.tableControl = options.tableControl;

            if (!this.tableControl) {
                throw "options.tableControl not set";
            }

            this._tableMods = this.tableControl._tableMods ? Solovis.deepCopy(this.tableControl._tableMods) : {};
        }


        public show() {
            var self = this;

            if (this._dialog) {
                return;
            }

            var tableMods = this._tableMods;

            var formDiv = $("<div>");

            var formBuilderDiv = $("<div>").appendTo(formDiv);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv
            });
            this._formBuilder = formBuilder;

            // Table Alignment       
            var tableAlignmentDataList = [
                { text: "Default", value: "" },
                { text: "Left", value: "left" },
                { text: "Center", value: "center" }
            ];

            formBuilder.addEntry({
                name: "tableAlignment",
                label: "Table Alignment",

                initialValue: Solovis.isNotNull(tableMods.marginCentered) ? (tableMods.marginCentered ? "center" : "left") : null,

                createEditor: function (createEditorOptions) {

                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        data: tableAlignmentDataList
                    });

                    return editorControl;
                }
            });

            // Aggregate Row Display       
            var aggregateDisplayDataList = [
                { text: "Default", value: "" },
                { text: "Inline", value: "inline" },
                { text: "Top", value: "top" },
                { text: "Bottom", value: "bottom" }
            ];

            formBuilder.addEntry({
                name: "aggregateRowDisplay",
                label: "Aggregate Row Display",

                initialValue: Solovis.isNotNull(tableMods.aggregateRowDisplay) ? tableMods.aggregateRowDisplay : null,

                createEditor: function (createEditorOptions) {

                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        data: aggregateDisplayDataList
                    });

                    return editorControl;
                }
            });

            // Group Header Column Span            
            formBuilder.addEntry({
                name: "groupHeaderColspan",
                label: "Group Header Column Span",

                initialValue: Solovis.isNotNull(tableMods.groupHeaderColspan) ? tableMods.groupHeaderColspan : null,

                createEditor: function (createEditorOptions) {

                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "number",
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Fit To Screen 
            formBuilder.addEntry({
                name: "fitToScreen",
                label: "Fit To Screen",

                initialValue: Solovis.isNotNull(tableMods.fitToScreen) ? tableMods.fitToScreen : false,

                editor: {
                    type: "bool"
                }
            });

            formBuilder.setupDone();


            var desiredWidth = Math.min($(window).width() * .9, formBuilder.width() + 20);
            var desiredHeight = Math.min($(window).height() * .9, 300);


            this._dialog = new Solovis.UI.Dialog({
                container: formDiv,

                title: "Table Settings",
                autoOpen: true,
                width: desiredWidth,
                height: desiredHeight,
                center: true,
                modal: true,
                destroyOnClose: true,
                actions: ["Close"],

                buttons: [
                    {
                        label: "OK",
                        click: function () {
                            var newTableMods = tableMods;
                            if (!newTableMods) {
                                newTableMods = {};
                            }

                            var centerTableValue = self._formBuilder.getValueByName("tableAlignment");
                            if (centerTableValue) {
                                newTableMods.marginCentered = (centerTableValue == "center");
                            }
                            else {
                                delete newTableMods.marginCentered;
                            }

                            var aggregateRowDisplayValue = self._formBuilder.getValueByName("aggregateRowDisplay");
                            if (aggregateRowDisplayValue) {
                                newTableMods.aggregateRowDisplay = aggregateRowDisplayValue;
                            }
                            else {
                                delete newTableMods.aggregateRowDisplay;
                            }

                            var groupHeaderColspanValue = self._formBuilder.getValueByName("groupHeaderColspan");
                            if (groupHeaderColspanValue) {
                                newTableMods.groupHeaderColspan = groupHeaderColspanValue;
                            }
                            else {
                                delete newTableMods.groupHeaderColspan;
                            }

                            var fitToScreenValue = self._formBuilder.getValueByName("fitToScreen");
                            if (fitToScreenValue) {
                                newTableMods.fitToScreen = fitToScreenValue;
                            }
                            else {
                                delete newTableMods.fitToScreen;
                            }

                            self.tableControl.updateTableMods(newTableMods);

                            self._dialog.close();
                        }
                    },

                    {
                        label: "Cancel",
                        click: function () {
                            self._dialog.close();
                        }
                    }
                ],
            });
        };
    }

}
